import React from 'react';
import Card from './card';
import Masonry from 'react-masonry-component';
import {ListingViewConstants} from '../../common/constants';

const CardView = (props) => {
    const { type, userTimezone, tzData } = props;
    const [scrolling, setScrolling] = React.useState(false);
    const scrollRef = React.useRef(null);

    const handleScroll = () => {
        setScrolling(true);
        if (!scrolling)
            return;
        const refPageScrollHeight = scrollRef.current.scrollHeight;
        const refpageOffset = scrollRef.current.offsetHeight;
        const refhtmlClientHeight = scrollRef.current.scrollTop;
        let data = (type === ListingViewConstants.Workkard) ? props.data.WorkkardsFullData : props.data.ActivitiesFullData;
        if ((refhtmlClientHeight + refpageOffset) >= (refPageScrollHeight - 10) && data.length) {
            setScrolling(false);
            props.onScrollHandler();
        } else {
            setScrolling(true);
        }
    };

    let data = (type === ListingViewConstants.Workkard) ? props.data.WorkkardsFullData : props.data.ActivitiesFullData;
    return (
        <div
            onScroll={handleScroll}
            ref={scrollRef}
            className="workKardScroll scrollArea"
        >
            <Masonry className={'workkards_list'}>
                {data && data.map((item, index) => <Card type={type} key={index} userTimezone={userTimezone} tzData={tzData} listingData={item} globalSearch={props.globalSearch} />)}
            </Masonry>
        </div>
    );
};

export default CardView;